const general = {
    'general': 'General',
    'general.yes': 'Yes',
    'general.no': 'No',
    'general.ok': 'Okay',
    'general.cancel': 'Cancel',
    'general.example': 'Example',

    'general.date': 'Date',

    'general.active': 'Active',
    'general.inactive': 'Inactive',

    'general.page_not_found': 'Page not found',
    'general.no_results_found': 'No results found',

    'general.no_attentions': 'No attention needed',

    'general.dashboard': 'Dashboard',
    'general.settings': 'Settings',

    'general.select_option': 'Make a choice',
    'general.select_all': 'Select all',

    'general.name': 'Name',
    'general.description': 'Description',
    'general.email': 'E-mail address',
    'general.password': 'Password',
    'general.password_confirm': 'Confirm password',

    'general.reseller': 'Reseller',
    'general.resellers': 'Resellers',

    'general.client': 'Customer',
    'general.clients': 'Customers',

    'general.feed': 'Feed',
    'general.feeds': 'Feeds',

    'general.webshop': 'Webshop',
    'general.webshop_type': 'Webshop type',
    'general.webshops': 'Webshops',

    'general.fields': 'Fields',
    'general.field': 'Field',

    'general.connection': 'Connection',
    'general.connections': 'Connections',

    'general.profile': 'Profile',
    'general.profiles': 'Profiles',

    'general.brands': 'Brands',
    'general.brand': 'Brand',

    'general.categories': 'Categories',
    'general.category': 'Category',

    'general.attributes': 'Attributes',
    'general.attribute': 'Attribute',

    'general.prices': 'Prices',
    'general.price': 'Price',

    'general.payment_interval': 'Pays per',

    'general.product_groups': 'Product groups',
    'general.product_group': 'Product group',

    'general.customer_groups': 'Customer groups',
    'general.customer_group': 'Customer group',

    'general.rule': 'Rule',

    'general.marge': 'Price margin ( percentage )',


    'general.company': 'Company',
    'general.company.name': 'Company name',
    'general.company.phone': 'Phone number',
    'general.company.website': 'Website',
    'general.company.iban': 'IBAN number',
    'general.company.chamber_of_commerce': 'CoC number',
    'general.company.vat_number': 'VAT number',
    'general.company.logo': 'Logo',

    'general.contact.name': 'Contact person',
    'general.contact.firstname': 'First name',
    'general.contact.middlename': 'Middle name',
    'general.contact.lastname': 'Last name',
    'general.contact.phone': 'Phone number',
    'general.contact.email': 'E-mail',

    'general.address.street': 'Street',
    'general.address.address': 'Street and house number',
    'general.address.zipcode': 'Zip code',
    'general.address.city': 'City',
    'general.address.country': 'Country',
    'general.address.state': 'State',

    'general.general_information': 'General information',
    'general.company_information': 'Company information',
    'general.contact_information': 'Contact information',
    'general.extra_information': 'Extra information',

    'general.invitation.invited': 'Invited',
    'general.invitation.send_to': 'Invitation sent to',

    'general.send_invitation': 'Send invitation',
    'general.send_invitation.sending': 'Sending invitation...',

    'general.resend_invitation': 'Resend invitation',
    'general.resend_invitation.explanation': 'Your invitation has been sent to %x. Enter a new email address to resend the invitation.',
    'general.resend_invitation.sending': 'Sending invitation...',
    'general.resend_invitation.other_email': 'Send invitation to another e-mail address',

    'general.save': 'Save',
    'general.save.saving': 'Saving...',

    'general.save_changes': 'Save changes',
    'general.save_changes.saving': 'Saving changes...',

    'general.continue_to_payment': 'Continue to payment',
    'general.continue_with_request': 'Request subscription',
    'general.loading': 'Loading...',

    'general.goto.dashboard': 'Go to dashboard',

    'general.register': 'Register',
    'general.register.step1': 'Register | My Company information',
    'general.register.step2': 'Register | My Contact information',
    'general.register.step3': 'Register | My Subscription plan',

    'general.current.customers': 'Current customers',
    'general.payment': 'Payment',
    'general.payments': 'Payments',

    'general.requests': 'Requests',

    'general.subscription.expired': 'Subscription expired',
    'general.subscription.false': 'Not subscribed',
    'general.admin': 'Admin',

    'general.status': 'Status',
    'general.exported': 'Exported',

    'general.location.type': 'Location type',
    'general.sync': 'Sync',

    'general.supported.software': 'Supported software',

    'general.subscription': 'Subscription',
    'general.subscription.type': 'Subscription type',
    'general.subscription.option': 'Subscription option',

    'general.faq': 'Frequently Asked Questions',
    'general.about': 'About us',
    'general.contact': 'Contact',
    'general.conditions': 'Terms and conditions',

    'general.languages': 'Languages',
    'general.language': 'Language',

    'general.file.choose': 'Choose file',

    'general.original': 'Original',
    'general.next_step': 'Next step',
    'general.previous_step': 'Previous step',

    'general.search': 'What are you looking for?',

    'general.dot': 'Dot (.)',
    'general.comma': 'Comma (,)',
    'general.dotcomma': 'Dotcomma (;)',
    'general.tab': 'Tab',
    'general.pipe': 'Pipe (|)',
    'general.double.quote': 'Double Quote (\"\)',
    'general.single.quote': 'Single Quote (\'\)',

    'general.alternative.categories': 'Alternatieve categorieen',

    'general.hour': 'Hour',
    'general.day': 'Day(s)',
    'general.week': 'Week(s)',
    'general.month': 'Month(s)',
    'general.sync_interval': 'Sync changed interval',
    'general.update_interval': 'Sync update interval',
    'general.interval': 'Interval',

    'general.profile.combine': 'Profile combine',

    'general.profile.add': 'Add profile',
    'general.profile.edit': 'Edit profile',

    'general.open': 'Open. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.paid': 'Paid. After verifying your account you can log in',
    'general.failed': 'Failed. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.expired': 'Expired. After verifying your account you can log in. You can try again after loggin in into your account',
    'general.canceled': 'Canceled. After verifying your account you can log in. You can try again after loggin in into your account',

    'general.user.open': 'Open. You can try again at the subscription page',
    'general.user.paid': 'Paid. Your subscription has been updated',
    'general.user.failed': 'Failed. You can try again at the subscription page',
    'general.user.expired': 'Expired. You can try again at the subscription page',
    'general.user.canceled': 'Canceled. You can try again at the subscription page',
    'general.none': 'None',

    'general.account.created': 'Account created. You can now login.',

    'general.switch': 'Switch',

    'general.switch.reseller': 'Client is now switched to the selected reseller.',

    'general.discount': 'Discount',
    'general.payment.yearly': 'I would like to pay yearly (20% discount)',
    'general.payment.monthly': 'I would like to pay monthly',

    'general.stacktrace': 'Stacktrace',
};

export default general;
